import * as React from "react"
import { SFProIcon, SFProIconProps } from "./SFProIcon"

export interface EyeVisibleIconProps extends Omit<SFProIconProps, 'symbol'> {}

/**
 * Eye visible icon using SF Pro font symbol (􀋭)
 *
 * This icon represents visible/shown state for visibility toggles.
 *
 * @example
 * ```tsx
 * <EyeVisibleIcon />
 * <EyeVisibleIcon size={16} weight="semibold" />
 * ```
 */
export const EyeVisibleIcon = React.forwardRef<HTMLSpanElement, EyeVisibleIconProps>(
  (props, ref) => {
    return <SFProIcon ref={ref} symbol="􀋭" {...props} />
  }
)

EyeVisibleIcon.displayName = "EyeVisibleIcon"
